export interface TimePeriod {
  amount: number;
  time_unit: "seconds" | "minutes" | "hours" | "days" | "weeks"
}
export const calculateIso8601DurationFromTimePeriod = (
  timePeriod: TimePeriod,
): string => {
  const { amount, time_unit } = timePeriod;

  if (amount <= 0) {
    throw new Error("Duration amount must be greater than 0");
  }

  switch (time_unit) {
    case "seconds":
      return `PT${amount}S`;
    case "minutes":
      return `PT${amount}M`;
    case "hours":
      return `PT${amount}H`;
    case "days":
      return `P${amount}D`;
    case "weeks":
      return `P${amount}W`;
    default:
      throw new Error(`Unsupported time unit: ${time_unit}`);
  }
};
